class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {}

  close() {
    this.mainDetailsToggle.classList.remove("menu-open");
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.hoverTimeout = null;

    const transitionEnd = (event) => {
      if (this.content !== event.target) return;
      if (this.mainDetailsToggle.classList.contains("menu-open")) return;
      this.mainDetailsToggle.removeAttribute("open");
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
    };

    this.mainDetailsToggle.addEventListener("transitionend", transitionEnd);
    this.mainDetailsToggle.addEventListener("transitioncancel", transitionEnd);

    this.addEventListener("mouseenter", this.onMouseEnter.bind(this));
    this.addEventListener("mouseleave", this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    window.clearTimeout(this.hoverTimeout);

    document.querySelectorAll("header-menu").forEach((menu) => {
      if (menu !== this) menu.close(true);
    });

    this.mainDetailsToggle.setAttribute("open", "");
    this.mainDetailsToggle.classList.add("menu-open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", "true");
  }

  onMouseLeave() {
    this.close();
  }

  close(immediate = false) {
    window.clearTimeout(this.hoverTimeout);
    this.mainDetailsToggle.classList.remove("menu-open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", "false");

    if (immediate) {
      this.mainDetailsToggle.removeAttribute("open");
      return;
    }

    this.hoverTimeout = window.setTimeout(() => {
      if (!this.mainDetailsToggle.classList.contains("menu-open")) {
        this.mainDetailsToggle.removeAttribute("open");
      }
    }, 260);
  }

  onToggle() {}
}

customElements.define("header-menu", HeaderMenu);
